import React from "react";
import RadioButton from "../RadioButton";

type BaseOption = {
  value: string;
  label: string;
  sublabel1?: string;
  sublabel2?: string;
  icon?: string;
};

export const renderRadioButton = <T extends BaseOption>(
  option: T,
  isSelected: boolean,
  onSelect: () => void,
): React.ReactNode => {
  return (
    <RadioButton
      value={option.value}
      label={option.label}
      sublabel1={"sublabel1" in option ? option.sublabel1 : undefined}
      sublabel2={"sublabel2" in option ? option.sublabel2 : undefined}
      checked={isSelected}
      onChange={onSelect}
      icon={option.icon ?? ""}
    />
  );
};
